import dashboard from './dashboard';
import admin from './admin';
import student from './student';

const menuItems = (role) => {
  let selectedMenu;
  switch (role) {
    case 'admin':
      selectedMenu = admin;
      break;
    case 'student':
      selectedMenu = student;
      break;
    default:
      selectedMenu = dashboard;
  }

  return selectedMenu;
};

export default menuItems;
